import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-stripped-progress-bar',
  templateUrl: './strippedProgressBar.component.html'
})

export class StrippedProgressBarComponent implements OnInit {

  @Input() show: boolean;
  @Input() width: string;
  @Input() height: string;
  @Input() border: string;

  private _styles: any;

  constructor() { }

  ngOnInit() {
    this._styles = {
      'width': Boolean(this.width) ? this.width : '100%',
      'height': Boolean(this.height) ? this.height : '20px',
      'border': Boolean(this.border) ? this.border : 'none'
    };
  }

  public get styles(): any {
    return this._styles;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/strippedProgressBar/strippedProgressBar.component.ts